/* Mostashop — sélection multi-produits de la collection « Nos partenaires ».
   Permet d'ajouter plusieurs produits affiliés Amazon à une sélection mémorisée
   dans le navigateur, puis de les envoyer en une fois dans un panier Amazon. */
(function () {
  'use strict';

  var STORAGE_KEY = 'mostashop:amazonSelection';
  var ASSOCIATE_TAG = 'mostaland-21';
  var CART_BASE_URL = 'https://www.amazon.fr/gp/aws/cart/add.html';

  function readSelection() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function writeSelection(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isValidAsin(asin) {
    return typeof asin === 'string' && /^[A-Za-z0-9]{10}$/.test(asin);
  }

  var selection = readSelection().filter(function (item) {
    return item && isValidAsin(item.asin) && item.title && item.qty > 0;
  });

  var bar, barRow, barCount, barCountLabel, barList, barNote, barToggle, barCta;
  var resizeTimer = null;

  function save() { writeSelection(selection); }

  function findItem(asin) {
    for (var i = 0; i < selection.length; i++) {
      if (selection[i].asin === asin) return selection[i];
    }
    return null;
  }

  function totalCount() {
    var n = 0;
    selection.forEach(function (it) { n += it.qty; });
    return n;
  }

  function buildCartUrl() {
    var params = [];
    selection.forEach(function (item, i) {
      var n = i + 1;
      params.push('ASIN.' + n + '=' + encodeURIComponent(item.asin));
      params.push('Quantity.' + n + '=' + encodeURIComponent(item.qty));
    });
    params.push('AssociateTag=' + encodeURIComponent(ASSOCIATE_TAG));
    return CART_BASE_URL + '?' + params.join('&');
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-mosta-select]').forEach(function (btn) {
      var asin = btn.getAttribute('data-asin');
      var label = btn.querySelector('[data-mosta-select-label]');
      if (findItem(asin)) {
        btn.classList.add('is-added');
        if (label) label.textContent = '✓ Dans ma sélection';
      } else {
        btn.classList.remove('is-added');
        if (label) label.textContent = '+ Ajouter à ma sélection';
      }
    });
  }

  /* Calcule et réserve exactement la place nécessaire en bas de page, que la
     liste soit repliée ou ouverte (jusqu'à 40% de la hauteur d'écran), afin
     que la barre ne masque jamais le pied de page ni les boutons flottants. */
  function updateBarSpace() {
    if (!bar || selection.length === 0) {
      document.documentElement.style.setProperty('--mosta-bar-space', '0px');
      return;
    }
    var cs = window.getComputedStyle(bar);
    var padTop = parseFloat(cs.paddingTop) || 0;
    var padBottom = parseFloat(cs.paddingBottom) || 0;
    var rowHeight = barRow ? barRow.offsetHeight : 0;
    var noteHeight = barNote ? barNote.offsetHeight : 0;
    var listHeight = 0;
    if (bar.classList.contains('is-open')) {
      var maxAllowed = window.innerHeight * 0.4;
      listHeight = Math.min(barList.scrollHeight, maxAllowed) + 10; /* marge d'ouverture */
    }
    var total = padTop + padBottom + rowHeight + noteHeight + listHeight;
    document.documentElement.style.setProperty('--mosta-bar-space', Math.ceil(total) + 'px');
  }

  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'mosta-bar';
    bar.setAttribute('data-mosta-bar', '');
    bar.innerHTML =
      '<div class="mosta-bar-row">' +
        '<button type="button" class="mosta-bar-count" data-mosta-toggle aria-expanded="false">' +
          '<span class="mosta-bar-count-badge" data-mosta-count>0</span>' +
          '<span data-mosta-count-label>article sélectionné</span>' +
          '<span class="mosta-bar-chevron" aria-hidden="true">&#9650;</span>' +
        '</button>' +
        '<span class="mosta-bar-spacer"></span>' +
        '<a class="btn btn--gold mosta-bar-cta" data-mosta-cta href="#" target="_blank" rel="sponsored noopener">Commander sur Amazon</a>' +
      '</div>' +
      '<p class="mosta-bar-note">En tant que Partenaire Amazon, je réalise un bénéfice sur les achats remplissant les conditions requises.</p>' +
      '<div class="mosta-bar-list" data-mosta-list></div>';
    document.body.appendChild(bar);

    barRow = bar.querySelector('.mosta-bar-row');
    barCount = bar.querySelector('[data-mosta-count]');
    barCountLabel = bar.querySelector('[data-mosta-count-label]');
    barList = bar.querySelector('[data-mosta-list]');
    barNote = bar.querySelector('.mosta-bar-note');
    barToggle = bar.querySelector('[data-mosta-toggle]');
    barCta = bar.querySelector('[data-mosta-cta]');

    /* Fermée par défaut : la liste ne s'ouvre qu'au clic sur ce bouton. */
    barToggle.addEventListener('click', function () {
      var open = bar.classList.toggle('is-open');
      barToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      updateBarSpace();
    });

    barList.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-mosta-qty-plus]');
      var minus = e.target.closest('[data-mosta-qty-minus]');
      var remove = e.target.closest('[data-mosta-remove]');
      if (plus) changeQty(plus.getAttribute('data-mosta-qty-plus'), 1);
      else if (minus) changeQty(minus.getAttribute('data-mosta-qty-minus'), -1);
      else if (remove) removeItem(remove.getAttribute('data-mosta-remove'));
    });

    window.addEventListener('resize', function () {
      if (resizeTimer) return;
      resizeTimer = setTimeout(function () { resizeTimer = null; updateBarSpace(); }, 150);
    }, { passive: true });

    return bar;
  }

  function changeQty(asin, delta) {
    var item = findItem(asin);
    if (!item) return;
    item.qty += delta;
    if (item.qty < 1) { removeItem(asin); return; }
    save();
    render();
  }

  function removeItem(asin) {
    selection = selection.filter(function (it) { return it.asin !== asin; });
    save();
    render();
    syncButtons();
  }

  function render() {
    ensureBar();
    var count = totalCount();
    var hasItems = selection.length > 0;

    document.body.classList.toggle('has-amazon-selection', hasItems);
    bar.classList.toggle('is-visible', hasItems);
    if (!hasItems) bar.classList.remove('is-open');

    if (barCount) barCount.textContent = String(count);
    if (barCountLabel) barCountLabel.textContent = count > 1 ? 'articles sélectionnés' : 'article sélectionné';

    if (barList) {
      barList.innerHTML = selection.map(function (item) {
        return (
          '<div class="mosta-bar-line">' +
            '<span class="mosta-bar-line-title">' + escapeHtml(item.title) + '</span>' +
            '<span class="mosta-bar-qty">' +
              '<button type="button" data-mosta-qty-minus="' + item.asin + '" aria-label="Diminuer la quantité de ' + escapeHtml(item.title) + '">&minus;</button>' +
              '<span>' + item.qty + '</span>' +
              '<button type="button" data-mosta-qty-plus="' + item.asin + '" aria-label="Augmenter la quantité de ' + escapeHtml(item.title) + '">+</button>' +
            '</span>' +
            '<button type="button" class="mosta-bar-remove" data-mosta-remove="' + item.asin + '" aria-label="Retirer ' + escapeHtml(item.title) + ' de la sélection">&times;</button>' +
          '</div>'
        );
      }).join('');
    }

    if (barCta) barCta.href = hasItems ? buildCartUrl() : '#';

    updateBarSpace();
  }

  function addOrToggle(asin, title) {
    if (findItem(asin)) { removeItem(asin); return; }
    selection.push({ asin: asin, title: title, qty: 1 });
    save();
    render();
    syncButtons();
  }

  function initButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mosta-select]');
      if (!btn) return;
      e.preventDefault();
      var asin = btn.getAttribute('data-asin');
      var title = btn.getAttribute('data-title') || '';
      if (!isValidAsin(asin)) return;
      addOrToggle(asin, title);
    });
  }

  function boot() {
    initButtons();
    syncButtons();
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Réaffiche l'état correct si l'éditeur de thème recharge la section. */
  document.addEventListener('shopify:section:load', function () {
    syncButtons();
    render();
  });
})();
